import { WorkBook, WorkSheet, utils, writeFile } from 'xlsx';
import { saveAs } from 'file-saver';
import { datePad } from '@app/shared/utils';
import { FormatFileType } from './format-file-type.enum';

export class Spreadsheet<T> {

    constructor(
        private name: string,
        private table?: Array<T>,
        private format = FormatFileType.EXCEL,
    ) { }

    public generateSpreadsheet(): void {
        const workSheet: WorkSheet = utils.json_to_sheet(this.table);
        const workBook: WorkBook = utils.book_new();
        utils.book_append_sheet(workBook, workSheet, this.name);
        writeFile(workBook, this.fileName);
    }

    get fileName(): string {
        const timestamp = new Date();
        const day = datePad(timestamp.getDate());
        const month = datePad(timestamp.getMonth() + 1);
        const hours = `${timestamp.getHours()}`;
        const minutes = `${timestamp.getMinutes()}`;
        const seconds = `${timestamp.getSeconds()}`;
        const dateFormat = `${timestamp.getFullYear()}${month}${day}`;
        const hourFormat = `${hours}${minutes}${seconds}`;
        return `${this.name}-${dateFormat}-${hourFormat}.${this.format}`;
    }

    public generate(data: Blob): void {
        if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveBlob(data, this.fileName);
        } else {
            const blob = new Blob([data]);
            const file = new File([blob], this.fileName);
            saveAs(file);
        }
    }

}
